import { baseURL } from "./Config";

// Uploads are stored as bare paths like "storage/mxc-ava-kai.svg". Rendered as-is they
// resolve against this app's own origin (/agencypanel/...) and come back as index.html,
// so every avatar is broken; prefixing the apex URL matches what LanguageSwitcher does.
export const assetUrl = (path, fallback) => {
  const value = String(path || "");
  if (!value) return fallback || "";
  if (/^(https?:|data:|blob:)/.test(value)) return value;
  return `${baseURL || ""}${value.replace(/^\/+/, "")}`;
};
